import React, { useState } from "react";
import { Button, TextField, Box, MenuItem, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import { LeagueListItem } from "../CreateRound/CreateRoundModels";
import { Team, TeamOverviewFilter } from "../TeamOverview/TeamOverviewModels";
import { BaseItemState } from "../Ticker2/Ticker2Models";
import TeamOverviewUtil from "../TeamOverview/TeamOverviewUtil";
import Ticker2Util from "../Ticker2/Ticker2Util";

interface TeamChooserProps {
    league?: LeagueListItem;
    onChange: (team: Team | undefined) => void;
}
interface TeamChooserState {
    searchName: string;
    pageSize: string;
    teamId: string;
    team: Team | undefined;
    leagueFilterEnabled: boolean;
}


const TeamChooser: React.FC<TeamChooserProps> = (props) => {
    const getDefaultFormState = () : TeamChooserState => {
        return {
            searchName: "",
            pageSize: "100",
            teamId: "",
            team: undefined,
            leagueFilterEnabled: props.league ? true : false
        };
    }
    
    const [formState, setFormState] = useState<TeamChooserState>(getDefaultFormState());
    const [actionError, setActionError] = useState<string>("");
    const [itemState, setItemState] = useState<BaseItemState<Team,number>>({
       items: [],
       more: false,
       lastId: 0,
       refreshing: false
    });

    const handleChange = (name: string, value: any) =>{
        //var prevValue = formState.[name];
        var fs = {...formState, [name]: value};
        if (name === "teamId") {
            if (!value || value.length <= 0) {
                fs.team = undefined;
            } else {
                var team = itemState.items.find(it => it.id === value);
                fs.team = team;
            }
            props.onChange(fs.team);
        } else if (name === "leagueFilterEnabled") {
            // setMore(false);
            // setPage(-1);
        }
        setFormState(fs);
    }
    const refreshTeams = (more: boolean) => {
        var caller = more ? "RefreshMore" : "Refresh";
        if (itemState.refreshing) {
            return;
        }
        var pageSize = parseInt(formState.pageSize);
        if (isNaN(pageSize) || pageSize < 1) {
            setActionError("Page size is not a number or less than 1");
            return;
        }
        var count = 0;
        var filter : TeamOverviewFilter | undefined= {};
        if (formState.searchName.trim().length > 0) {
            filter.namePattern = formState.searchName;
            count++;
        }
        if (formState.leagueFilterEnabled && props.league) {
            filter.leagueId = parseInt(props.league.id);
            count++;
        }
        if (count <= 0) {
            filter = undefined;
        }
        var rs : BaseItemState<Team,number> = {
            items:[],
            more: false,
            lastId: 0,
            refreshing: false
        };
        var lastId = more ? itemState.lastId : 0;
        if (lastId > 0) {
            rs.items = itemState.items;
        }
        var from : Date | undefined = undefined
        var to : Date | undefined = undefined
        var success = false;
        itemState.refreshing = true;
        setActionError("");
        TeamOverviewUtil.getTeams(pageSize, from, to, lastId, filter).then( resp => {
            if (!resp.success) {
                setActionError(`${caller} error: ${resp.message}`);
                return;
            }
            var listResponse = resp.item;
            if (listResponse) {
                if (listResponse.items && listResponse.items.length > 0) {
                    if (lastId > 0) {
                        for (const item of listResponse.items) {
                            rs.items.push(item);
                        }
                    } else {
                        rs.items = listResponse.items
                    }
                    rs.lastId = listResponse.items[listResponse.items.length - 1].id;
                    rs.items.sort((a,b) => a.name.localeCompare(b.name));
                    if (listResponse.pageSize <= listResponse.items.length) {
                        rs.more = true;
                    }
                }           
            }
            success = true;

        }).catch( error => {
            setActionError(CreateRoundUtil.getExceptionMessage(error, false, `${caller} error`));
        }).finally( () => {
            if (success || lastId <= 0) {
                setItemState(rs);
            }
            itemState.refreshing = false;
        });
    }
    const onSearchClick = (): void => {
        refreshTeams(false);
    }
    const onMore = () => {
        refreshTeams(true);
     };

    var searchValid = true;
    var valid = true;
    var pageSizeErr = "";
    if (formState.pageSize.length === 0){
        searchValid = false;
        pageSizeErr = "Required";
    } else {
        var pageSize = parseInt(formState.pageSize);
        if (isNaN(pageSize) || pageSize < 1){
            pageSizeErr = "Invalid int (1-n)"
        }
    }

    var teamIdErr = "";
    if (formState.teamId === ""){
        valid = false;
        teamIdErr = "Required";
    } 

    var searchEnabled = (searchValid && !itemState.refreshing);
    var saveEnabled = (valid && !itemState.refreshing);
    var saveErrorBox = null;
    if (actionError.length > 0) {
        saveErrorBox = (<Box  color="red">{actionError}</Box>);
    }
   
    var teamHelperText = formState.team ? `id:${formState.team.id}; providerId:${formState.team.providerId}` : "";
    if (teamHelperText.length > 0){
        teamHelperText += "; ";
    }
    var info = Ticker2Util.toItemStateString(itemState);
    teamHelperText += info;
    var leagueBox = null;
    if (props.league) {
        leagueBox = (
        <Box paddingTop={1} display="flex" alignItems="center">
            <FormControlLabel control={<Checkbox checked={formState.leagueFilterEnabled} name="leagueFilterEnabled" onChange={e => handleChange("leagueFilterEnabled", e.target.checked)} style={{padding: 0}} />} label={`League filter: ${props.league.name} (${props.league.id})`} />
        </Box>);
    }
    return (
        <div>
            {leagueBox}
            <Box paddingTop={1} display="flex" alignItems="center">
                <TextField
                    name="pageSize" label="Page size" type="number" value={formState.pageSize} style={{ width: 100 }}
                    error={pageSizeErr && pageSizeErr.length ? true : false}
                    helperText={pageSizeErr}
                    onChange={e => handleChange("pageSize", e.target.value)}
                />
                <span style={{ padding: 2 }}></span>
                <TextField
                    name="searchName"
                    label="Search name"
                    value={formState.searchName}
                    onChange={e => handleChange("searchName", e.target.value)}
                />
                <span style={{ padding: 2 }}></span>
                <Button variant="contained" color="secondary" type="button" size="small" onClick={onSearchClick} disabled={!searchEnabled}>
                    Search
                </Button>
            </Box>
            <Box paddingTop={1} display="flex" alignItems="center">

                <TextField
                    name="teamId"
                    label="Team"
                    select
                    value={formState.teamId}
                    onChange={e => handleChange("teamId", e.target.value)}
                    style={{ width: 500 }}
                    error={(teamIdErr && teamIdErr.length > 0) ? true : false}
                    helperText={(teamIdErr && teamIdErr.length > 0) ? teamIdErr : teamHelperText}
                >
                    <MenuItem key="" value="" />
                    {itemState.items.map((team, teamIndex) => (
                        <MenuItem key={`team_${teamIndex}`} value={team.id}>
                            {`${team.name} (${team.id}; ${team.providerId})`}
                        </MenuItem>
                    ))}
                </TextField>
                <span style={{ padding: 2 }}></span>
                <Button variant="contained" color="secondary" size="small" disabled={itemState.refreshing || !itemState.more} onClick={e => onMore()}>
                    More
                </Button>
            </Box>
            {saveErrorBox} 
        </div>
    );
};

export default TeamChooser;

